import { createAction } from 'redux-actions';

import * as MENU from 'constants/menu';
import { postLogout } from './header';

export const show = createAction(MENU.SHOW);
export const hide = createAction(MENU.HIDE);

export { postLogout };
